import React, { useState, useEffect } from 'react';
import './App.css';
import MarketsPage from './MarketsPage';
import config from './config';

// Language translations
const translations = {
  English: {
    searchPlaceholder: "Search for brokers...",
    login: "Login",
    register: "Register",
    home: "Home",
    brokers: "Brokers",
    reviews: "Reviews",
    education: "Education",
    news: "News",
    tools: "Tools",
    about: "About",
    contact: "Contact",
    topBrokersTitle: "Top Rated Forex Brokers",
    topBrokersSubtitle: "Compare the best regulated forex brokers based on real user reviews and ratings",
    readReview: "Read Review",
    visitBroker: "Visit Broker",
    inquiryTitle: "Need Help Choosing the Right Broker?",
    inquiryText: "Finding the perfect forex broker can be overwhelming with hundreds of options available. Our comprehensive analysis helps you make informed decisions based on:",
    regulation: "Regulation & Security",
    spreads: "Competitive Spreads",
    deposits: "Minimum Deposits",
    support: "Customer Support",
    speed: "Execution Speed",
    safety: "Fund Safety",
    inquiryText2: "Get personalized broker recommendations based on your trading style, experience level, and investment goals. Our expert team analyzes thousands of user reviews to provide you with the most accurate and up-to-date information.",
    searchTitle: "Find Your Perfect Broker",
    searchSubtitle: "Search through our database of 500+ regulated forex brokers",
    searchPlaceholder2: "Enter broker name or search by features...",
    searchBrokers: "Search Brokers",
    allBrokers: "All Brokers",
    lowSpread: "Low Spread",
    highLeverage: "High Leverage",
    lowDeposit: "Low Deposit",
    regulated: "Regulated",
    spreadFrom: "Spread from:",
    minDeposit: "Min Deposit:",
    regulationLabel: "Regulation:",
    pips: "pips",
    reviews: "reviews",
    markets: "Markets",
    forex: "Forex",
    stocks: "Stocks",
    commodities: "Commodities",
    indices: "Indices",
    crypto: "Crypto",
    livePrices: "Live Prices",
    change: "Change",
    volume: "Volume",
    high: "High",
    low: "Low",
    open: "Open",
    close: "Close",
    buy: "Buy",
    sell: "Sell",
    chart: "Chart",
    news: "News",
    analysis: "Analysis"
  },
  हिंदी: {
    searchPlaceholder: "ब्रोकर्स खोजें...",
    login: "लॉगिन",
    register: "रजिस्टर",
    home: "होम",
    brokers: "ब्रोकर्स",
    reviews: "समीक्षाएं",
    education: "शिक्षा",
    news: "समाचार",
    tools: "उपकरण",
    about: "हमारे बारे में",
    contact: "संपर्क",
    topBrokersTitle: "शीर्ष रेटेड फॉरेक्स ब्रोकर्स",
    topBrokersSubtitle: "वास्तविक उपयोगकर्ता समीक्षाओं और रेटिंग के आधार पर सर्वश्रेष्ठ विनियमित फॉरेक्स ब्रोकर्स की तुलना करें",
    readReview: "समीक्षा पढ़ें",
    visitBroker: "ब्रोकर देखें",
    inquiryTitle: "सही ब्रोकर चुनने में मदद चाहिए?",
    inquiryText: "सैकड़ों विकल्पों के साथ सही फॉरेक्स ब्रोकर ढूंढना चुनौतीपूर्ण हो सकता है। हमारा व्यापक विश्लेषण आपको सूचित निर्णय लेने में मदद करता है:",
    regulation: "विनियमन और सुरक्षा",
    spreads: "प्रतिस्पर्धी स्प्रेड",
    deposits: "न्यूनतम जमा",
    support: "ग्राहक सहायता",
    speed: "निष्पादन गति",
    safety: "फंड सुरक्षा",
    inquiryText2: "अपनी ट्रेडिंग शैली, अनुभव स्तर और निवेश लक्ष्यों के आधार पर व्यक्तिगत ब्रोकर सिफारिशें प्राप्त करें।",
    searchTitle: "अपना सही ब्रोकर खोजें",
    searchSubtitle: "500+ विनियमित फॉरेक्स ब्रोकर्स के हमारे डेटाबेस में खोजें",
    searchPlaceholder2: "ब्रोकर का नाम दर्ज करें या सुविधाओं के अनुसार खोजें...",
    searchBrokers: "ब्रोकर्स खोजें",
    allBrokers: "सभी ब्रोकर्स",
    lowSpread: "कम स्प्रेड",
    highLeverage: "उच्च लीवरेज",
    lowDeposit: "कम जमा",
    regulated: "विनियमित",
    spreadFrom: "स्प्रेड:",
    minDeposit: "न्यूनतम जमा:",
    regulationLabel: "विनियमन:",
    pips: "पिप्स",
    reviews: "समीक्षाएं",
    markets: "बाजार",
    forex: "फॉरेक्स",
    stocks: "स्टॉक्स",
    commodities: "कमोडिटीज",
    indices: "इंडेक्स",
    crypto: "क्रिप्टो",
    livePrices: "लाइव प्राइस",
    change: "परिवर्तन",
    volume: "वॉल्यूम",
    high: "उच्च",
    low: "निम्न",
    open: "खुला",
    close: "बंद",
    buy: "खरीदें",
    sell: "बेचें",
    chart: "चार्ट",
    news: "समाचार",
    analysis: "विश्लेषण"
  },
  اردو: {
    searchPlaceholder: "بروکرز تلاش کریں...",
    login: "لاگ ان",
    register: "رجسٹر",
    home: "ہوم",
    brokers: "بروکرز",
    reviews: "جائزے",
    education: "تعلیم",
    news: "خبریں",
    tools: "اوزار",
    about: "ہمارے بارے میں",
    contact: "رابطہ",
    topBrokersTitle: "بہترین ریٹڈ فاریکس بروکرز",
    topBrokersSubtitle: "حقیقی صارفین کے جائزوں اور ریٹنگز کی بنیاد پر بہترین ریگولیٹڈ فاریکس بروکرز کا موازنہ کریں",
    readReview: "جائزہ پڑھیں",
    visitBroker: "بروکر دیکھیں",
    inquiryTitle: "صحیح بروکر منتخب کرنے میں مدد چاہیے؟",
    inquiryText: "سینکڑوں اختیارات کے ساتھ صحیح فاریکس بروکر تلاش کرنا مشکل ہو سکتا ہے۔",
    regulation: "ریگولیشن اور سیکیورٹی",
    spreads: "مسابقتی سپریڈ",
    deposits: "کم سے کم ڈپازٹ",
    support: "کسٹمر سپورٹ",
    speed: "ایگزیکوشن اسپیڈ",
    safety: "فنڈ سیفٹی",
    inquiryText2: "اپنی ٹریڈنگ سٹائل، تجربے کی سطح اور سرمایہ کاری کے اہداف کی بنیاد پر ذاتی بروکر کی سفارشات حاصل کریں۔",
    searchTitle: "اپنا بہترین بروکر تلاش کریں",
    searchSubtitle: "500+ ریگولیٹڈ فاریکس بروکرز کے ہمارے ڈیٹا بیس میں تلاش کریں",
    searchPlaceholder2: "بروکر کا نام درج کریں یا خصوصیات کے مطابق تلاش کریں...",
    searchBrokers: "بروکرز تلاش کریں",
    allBrokers: "تمام بروکرز",
    lowSpread: "کم سپریڈ",
    highLeverage: "اعلی لیوریج",
    lowDeposit: "کم ڈپازٹ",
    regulated: "ریگولیٹڈ",
    spreadFrom: "سپریڈ:",
    minDeposit: "کم سے کم ڈپازٹ:",
    regulationLabel: "ریگولیشن:",
    pips: "پپس",
    reviews: "جائزے",
    markets: "مارکیٹس",
    forex: "فاریکس",
    stocks: "اسٹاکس",
    commodities: "کموڈٹیز",
    indices: "انڈیکس",
    crypto: "کرپٹو",
    livePrices: "لائیو پرائس",
    change: "تبدیلی",
    volume: "حجم",
    high: "بلند",
    low: "کم",
    open: "کھلا",
    close: "بند",
    buy: "خریدیں",
    sell: "بیچیں",
    chart: "چارٹ",
    news: "خبریں",
    analysis: "تجزیہ"
  },
  বাংলা: {
    searchPlaceholder: "ব্রোকার খুঁজুন...",
    login: "লগইন",
    register: "নিবন্ধন",
    home: "হোম",
    brokers: "ব্রোকার",
    reviews: "পর্যালোচনা",
    education: "শিক্ষা",
    news: "সংবাদ",
    tools: "সরঞ্জাম",
    about: "আমাদের সম্পর্কে",
    contact: "যোগাযোগ",
    topBrokersTitle: "শীর্ষ রেটেড ফরেক্স ব্রোকার",
    topBrokersSubtitle: "বাস্তব ব্যবহারকারীর পর্যালোচনা এবং রেটিংয়ের ভিত্তিতে সেরা নিয়ন্ত্রিত ফরেক্স ব্রোকার তুলনা করুন",
    readReview: "পর্যালোচনা পড়ুন",
    visitBroker: "ব্রোকার দেখুন",
    inquiryTitle: "সঠিক ব্রোকার বেছে নিতে সাহায্য চাইছেন?",
    inquiryText: "শত শত বিকল্পের সাথে সঠিক ফরেক্স ব্রোকার খুঁজে পাওয়া কঠিন হতে পারে।",
    regulation: "নিয়ন্ত্রণ ও নিরাপত্তা",
    spreads: "প্রতিযোগিতামূলক স্প্রেড",
    deposits: "ন্যূনতম আমানত",
    support: "গ্রাহক সহায়তা",
    speed: "নিষ্পাদন গতি",
    safety: "তহবিল নিরাপত্তা",
    inquiryText2: "আপনার ট্রেডিং স্টাইল, অভিজ্ঞতার স্তর এবং বিনিয়োগের লক্ষ্যের ভিত্তিতে ব্যক্তিগতকৃত ব্রোকার সুপারিশ পান।",
    searchTitle: "আপনার নিখুঁত ব্রোকার খুঁজুন",
    searchSubtitle: "500+ নিয়ন্ত্রিত ফরেক্স ব্রোকারের আমাদের ডাটাবেসে অনুসন্ধান করুন",
    searchPlaceholder2: "ব্রোকারের নাম লিখুন বা বৈশিষ্ট্য অনুসারে অনুসন্ধান করুন...",
    searchBrokers: "ব্রোকার অনুসন্ধান করুন",
    allBrokers: "সব ব্রোকার",
    lowSpread: "কম স্প্রেড",
    highLeverage: "উচ্চ লিভারেজ",
    lowDeposit: "কম আমানত",
    regulated: "নিয়ন্ত্রিত",
    spreadFrom: "স্প্রেড:",
    minDeposit: "ন্যূনতম আমানত:",
    regulationLabel: "নিয়ন্ত্রণ:",
    pips: "পিপস",
    reviews: "পর্যালোচনা",
    markets: "বাজার",
    forex: "ফরেক্স",
    stocks: "স্টক",
    commodities: "কমোডিটি",
    indices: "ইনডেক্স",
    crypto: "ক্রিপ্টো",
    livePrices: "লাইভ প্রাইস",
    change: "পরিবর্তন",
    volume: "ভলিউম",
    high: "উচ্চ",
    low: "নিম্ন",
    open: "খোলা",
    close: "বন্ধ",
    buy: "কিনুন",
    sell: "বিক্রি করুন",
    chart: "চার্ট",
    news: "সংবাদ",
    analysis: "বিশ্লেষণ"
  },
  தமிழ்: {
    searchPlaceholder: "ப்ரோக்கர்களைத் தேடுங்கள்...",
    login: "உள்நுழைவு",
    register: "பதிவு",
    home: "முகப்பு",
    brokers: "ப்ரோக்கர்கள்",
    reviews: "விமர்சனங்கள்",
    education: "கல்வி",
    news: "செய்திகள்",
    tools: "கருவிகள்",
    about: "எங்களைப் பற்றி",
    contact: "தொடர்பு",
    topBrokersTitle: "சிறந்த மதிப்பிடப்பட்ட ஃபோரெக்ஸ் ப்ரோக்கர்கள்",
    topBrokersSubtitle: "உண்மையான பயனர் விமர்சனங்கள் மற்றும் மதிப்பீடுகளின் அடிப்படையில் சிறந்த ஒழுங்குபடுத்தப்பட்ட ஃபோரெக்ஸ் ப்ரோக்கர்களை ஒப்பிடுங்கள்",
    readReview: "விமர்சனத்தைப் படியுங்கள்",
    visitBroker: "ப்ரோக்கரைப் பார்வையிடுங்கள்",
    inquiryTitle: "சரியான ப்ரோக்கரைத் தேர்ந்தெடுக்க உதவி தேவையா?",
    inquiryText: "நூற்றுக்கணக்கான விருப்பங்களுடன் சரியான ஃபோரெக்ஸ் ப்ரோக்கரைக் கண்டுபிடிப்பது கடினமாக இருக்கலாம்.",
    regulation: "ஒழுங்குமுறை மற்றும் பாதுகாப்பு",
    spreads: "போட்டி ஸ்ப்ரெட்கள்",
    deposits: "குறைந்தபட்ச வைப்புத்தொகை",
    support: "வாடிக்கையாளர் ஆதரவு",
    speed: "செயல்படுத்தல் வேகம்",
    safety: "நிதி பாதுகாப்பு",
    inquiryText2: "உங்கள் வர்த்தக பாணி, அனுபவ நிலை மற்றும் முதலீட்டு இலக்குகளின் அடிப்படையில் தனிப்பட்ட ப்ரோக்கர் பரிந்துரைகளைப் பெறுங்கள்.",
    searchTitle: "உங்கள் சரியான ப்ரோக்கரைக் கண்டறியுங்கள்",
    searchSubtitle: "500+ ஒழுங்குபடுத்தப்பட்ட ஃபோரெக்ஸ் ப்ரோக்கர்களின் எங்கள் தரவுத்தளத்தில் தேடுங்கள்",
    searchPlaceholder2: "ப்ரோக்கர் பெயரை உள்ளிடவும் அல்லது அம்சங்களின்படி தேடவும்...",
    searchBrokers: "ப்ரோக்கர்களைத் தேடுங்கள்",
    allBrokers: "அனைத்து ப்ரோக்கர்களும்",
    lowSpread: "குறைந்த ஸ்ப்ரெட்",
    highLeverage: "உயர் லெவரேஜ்",
    lowDeposit: "குறைந்த வைப்புத்தொகை",
    regulated: "ஒழுங்குபடுத்தப்பட்ட",
    spreadFrom: "ஸ்ப்ரெட்:",
    minDeposit: "குறைந்தபட்ச வைப்புத்தொகை:",
    regulationLabel: "ஒழுங்குமுறை:",
    pips: "பிப்ஸ்",
    reviews: "விமர்சனங்கள்",
    markets: "சந்தைகள்",
    forex: "வெளிநாட்டு செலாவணி",
    stocks: "பங்குகள்",
    commodities: "பண்டங்கள்",
    indices: "குறியீடுகள்",
    crypto: "கிரிப்டோ",
    livePrices: "நேரலை விலைகள்",
    change: "மாற்றம்",
    volume: "அளவு",
    high: "உயர்",
    low: "குறைந்த",
    open: "திறந்த",
    close: "மூடிய",
    buy: "வாங்கு",
    sell: "விற்கு",
    chart: "வரைபடம்",
    news: "செய்திகள்",
    analysis: "பகுப்பாய்வு"
  },
  తెలుగు: {
    searchPlaceholder: "బ్రోకర్లను శోధించండి...",
    login: "లాగిన్",
    register: "నమోదు",
    home: "హోమ్",
    brokers: "బ్రోకర్లు",
    reviews: "సమీక్షలు",
    education: "విద్య",
    news: "వార్తలు",
    tools: "పనిముట్లు",
    about: "మా గురించి",
    contact: "సంప్రదించండి",
    topBrokersTitle: "టాప్ రేటెడ్ ఫోరెక్స్ బ్రోకర్లు",
    topBrokersSubtitle: "నిజమైన వినియోగదారు సమీక్షలు మరియు రేటింగ్ల ఆధారంగా ఉత్తమ నియంత్రిత ఫోరెక్స్ బ్రోకర్లను పోల్చండి",
    readReview: "సమీక్ష చదవండి",
    visitBroker: "బ్రోకర్ చూడండి",
    inquiryTitle: "సరైన బ్రోకర్ ఎంచుకోవడంలో సహాయం కావాలా?",
    inquiryText: "వందలాది ఎంపికలతో సరైన ఫోరెక్స్ బ్రోకర్ కనుగొనడం కష్టంగా ఉండవచ్చు.",
    regulation: "నియంత్రణ మరియు భద్రత",
    spreads: "పోటీ స్ప్రెడ్లు",
    deposits: "కనీసం జమ",
    support: "కస్టమర్ మద్దతు",
    speed: "అమలు వేగం",
    safety: "ఫండ్ భద్రత",
    inquiryText2: "మీ ట్రేడింగ్ స్టైల్, అనుభవ స్థాయి మరియు పెట్టుబడి లక్ష్యాల ఆధారంగా వ్యక్తిగత బ్రోకర్ సిఫార్సులను పొందండి.",
    searchTitle: "మీ సరైన బ్రోకర్ కనుగొనండి",
    searchSubtitle: "500+ నియంత్రిత ఫోరెక్స్ బ్రోకర్ల మా డేటాబేస్‌లో శోధించండి",
    searchPlaceholder2: "బ్రోకర్ పేరును నమోదు చేయండి లేదా లక్షణాల ప్రకారం శోధించండి...",
    searchBrokers: "బ్రోకర్లను శోధించండి",
    allBrokers: "అన్ని బ్రోకర్లు",
    lowSpread: "తక్కువ స్ప్రెడ్",
    highLeverage: "అధిక లివరేజ్",
    lowDeposit: "తక్కువ జమ",
    regulated: "నియంత్రిత",
    spreadFrom: "స్ప్రెడ్:",
    minDeposit: "కనీసం జమ:",
    regulationLabel: "నియంత్రణ:",
    pips: "పిప్స్",
    reviews: "సమీక్షలు",
    markets: "మార్కెట్లు",
    forex: "ఫోరెక్స్",
    stocks: "స్టాక్స్",
    commodities: "కమోడిటీలు",
    indices: "ఇండెక్స్",
    crypto: "క్రిప్టో",
    livePrices: "లైవ్ ధరలు",
    change: "మార్పు",
    volume: "వాల్యూమ్",
    high: "అధిక",
    low: "తక్కువ",
    open: "తెరిచి",
    close: "మూసి",
    buy: "కొనుగోలు",
    sell: "అమ్మకం",
    chart: "చార్ట్",
    news: "వార్తలు",
    analysis: "విశ్లేషణ"
  }
};

// Top Wrapper Component
const TopWrapper = ({ selectedLanguage, setSelectedLanguage, searchQuery, setSearchQuery, t, isScrolled }) => {
  const languages = [
    'English',
    'हिंदी',
    'اردو',
    'বাংলা',
    'தமிழ்',
    'తెలుగు',
    'العربية',
    'Español',
    'Français',
    'Türkçe',
    'Bahasa Indonesia',
    'Português',
    'Русский',
    '中文',
    '日本語',
    'Deutsch',
    'Italiano'
  ];
  
  return (
    <div className={`top-wrapper ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="top-bar">
          <div className="top-left">
            <div className="company-brand">
              <img
                className="company-logo"
                src={`${process.env.PUBLIC_URL}/forexumpire_logo.png`}
                alt="ForexUmpire"
              />
            </div>
          </div>
          <div className="top-center">
            <div className="search-container">
              <span className="material-icons">search</span>
              <input 
                type="text" 
                placeholder="Search brokers by name"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button className="search-btn">
                <span className="material-icons">search</span>
              </button>
            </div>
          </div>
          <div className="top-right">
            <div className="language-selector">
              <span className="material-icons">language</span>
              <select 
                value={selectedLanguage} 
                onChange={(e) => setSelectedLanguage(e.target.value)}
              >
                {languages.map(lang => (
                  <option key={lang} value={lang}>{lang}</option>
                ))}
              </select>
            </div>
            <div className="user-actions">
              <button className="btn-login">
                <span className="material-icons">login</span>
                {t.login}
              </button>
              <button className="btn-register">
                <span className="material-icons">person_add</span>
                {t.register}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Navigation Component
const Navigation = ({ t, currentPage, setCurrentPage, isScrolled }) => {
  const navItems = [
    { id: 'home', icon: 'home', text: t.home },
    { id: 'rankings', icon: 'emoji_events', text: 'Rankings' },
    { id: 'news', icon: 'article', text: t.news },
    { id: 'education', icon: 'school', text: t.education },
    { id: 'tools', icon: 'build', text: t.tools },
    { id: 'brokers', icon: 'account_balance', text: t.brokers },
    { id: 'markets', icon: 'show_chart', text: t.markets }
  ];
  
  const handleNavClick = (pageId) => {
    setCurrentPage(pageId);
    // Update URL
    if (pageId === 'home') {
      window.history.pushState({}, '', '/');
    } else {
      window.history.pushState({}, '', `/${pageId}`);
    }
  };

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-menu">
          {navItems.map(item => (
            <button
              key={item.id}
              className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
            >
              <span className="material-icons">{item.icon}</span>
              {item.text}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

// Broker Card Component
const BrokerCard = ({ broker, t, onVisitBroker }) => {
  // Convert rating to number and ensure it's between 0 and 5
  const rating = broker.rating !== null && broker.rating !== undefined 
    ? Math.max(0, Math.min(5, parseFloat(broker.rating) || 0)) 
    : 0;
  const reviews = broker.reviews || 0;
  const spread = broker.spread !== undefined && broker.spread !== null ? broker.spread : '-';
  const minDeposit = broker.minDeposit !== undefined && broker.minDeposit !== null ? broker.minDeposit : '-';
  const regulation = broker.regulation !== undefined && broker.regulation !== null ? broker.regulation : '-';
  const name = broker.name !== undefined && broker.name !== null ? broker.name : '-';
  const logo = broker.logo !== undefined && broker.logo !== null ? broker.logo : '-';
  const logoUrl = broker.logoUrl || null;

  const regulated = broker.regulated !== undefined ? broker.regulated : false;

  return (
    <div className="broker-card">
      <div className="broker-rank">#{broker.rank || '-'}</div>
      <div className="broker-header">
        <div className="broker-logo-section">
          {regulated ? (
            <div className="regulated-badge">
              <span>Regulated</span>
            </div>
          ) : (
            <div className="non-regulated-badge">
              <span>No Regulation</span>
            </div>
          )}
          <div className={`broker-logo ${logoUrl ? 'has-image' : ''}`}>
            {logoUrl ? (
              <>
                <img 
                  src={logoUrl} 
                  alt={name}
                  className="broker-logo-img"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const textSpan = e.target.parentElement.querySelector('span');
                    if (textSpan) {
                      textSpan.style.display = 'inline';
                    }
                    e.target.parentElement.classList.remove('has-image');
                  }}
                />
                <span style={{ display: 'none' }}>{logo}</span>
              </>
            ) : (
              <span>{logo}</span>
            )}
          </div>
        </div>
        <div className="broker-info">
          <h3>{name}</h3>
          <div className="broker-rating">
            <div className="stars">
              {[...Array(5)].map((_, i) => {
                const starNumber = i + 1;
                const fullStars = Math.floor(rating);
                const decimalPart = rating - fullStars;
                
                // Check if star should be fully filled
                const isFilled = starNumber <= fullStars;
                // Check if this is the next star after full stars and has a decimal part
                // Also handle case where rating is exactly 5.0 (all stars filled)
                const isPartial = starNumber === fullStars + 1 && decimalPart > 0 && rating < 5;
                const fillPercentage = isPartial ? decimalPart * 100 : 0;
                
                return (
                  <span key={i} className={`star ${isFilled ? 'filled' : ''} ${isPartial ? 'partial' : ''}`}>
                    {isPartial ? (
                      <span className="star-partial-wrapper">
                        <span className="star-partial-empty">★</span>
                        <span 
                          className="star-partial-filled" 
                          style={{ 
                            clipPath: `inset(0 ${100 - fillPercentage}% 0 0)`,
                            WebkitClipPath: `inset(0 ${100 - fillPercentage}% 0 0)`
                          }}
                        >
                          ★
                        </span>
                      </span>
                    ) : (
                      '★'
                    )}
                  </span>
                );
              })}
            </div>
            <span className="rating-text">{rating !== null && rating !== undefined ? `${rating.toFixed(1)}/5` : '-'}</span>
            <span className="reviews-count">({reviews !== null && reviews !== undefined ? reviews.toLocaleString() : '-'} {t.reviews})</span>
          </div>
        </div>
      </div>
      <div className="broker-details">
        <div className="detail-row">
          <span className="detail-label">{t.spreadFrom}</span>
          <span className="detail-value">{spread === '-' ? '-' : `${spread} ${t.pips}`}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">{t.minDeposit}</span>
          <span className="detail-value">{minDeposit}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">{t.regulationLabel}</span>
          <span className="detail-value">{regulation}</span>
        </div>
      </div>
      <div className="broker-actions">
        <button className="btn-review">{t.readReview}</button>
        <button className="btn-visit" onClick={() => onVisitBroker(broker)}>{t.visitBroker}</button>
      </div>
    </div>
  );
};

// Top Brokers Section Component
const TopBrokersSection = ({ topBrokers, t, onVisitBroker, loading, error }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredBrokers, setFilteredBrokers] = useState(topBrokers);

  // Filter brokers based on search query and active filter
  const filterBrokers = () => {
    let filtered = topBrokers || [];

    // Apply search filter - search by name, regulation, and other details
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(broker => 
        (broker.name && broker.name.toLowerCase().includes(query)) ||
        (broker.regulation && broker.regulation.toLowerCase().includes(query)) ||
        (broker.spread && broker.spread.toString().includes(query)) ||
        (broker.minDeposit && broker.minDeposit.toLowerCase().includes(query)) ||
        (broker.logo && broker.logo.toLowerCase().includes(query))
      );
    }

    // Apply category filter
    switch (activeFilter) {
      case 'lowSpread':
        filtered = filtered.filter(broker => {
          if (!broker.spread || broker.spread === '-') return false;
          const spreadValue = parseFloat(broker.spread);
          return !isNaN(spreadValue) && spreadValue <= 0.5;
        });
        break;
      case 'highLeverage':
        // This filter might need to be updated based on API data
        filtered = filtered.filter(broker => broker.name && (broker.name === 'FXTM' || broker.name === 'IC Markets'));
        break;
      case 'lowDeposit':
        filtered = filtered.filter(broker => {
          if (!broker.minDeposit || broker.minDeposit === '-') return false;
          const depositValue = parseFloat(broker.minDeposit.replace('$', '').replace(',', ''));
          return !isNaN(depositValue) && depositValue <= 100;
        });
        break;
      case 'regulated':
        filtered = filtered.filter(broker => 
          broker.regulation && 
          broker.regulation !== '-' &&
          (broker.regulation.includes('FCA') || 
           broker.regulation.includes('ASIC') || 
           broker.regulation.includes('CySEC') ||
           broker.regulation.includes('ASIC'))
        );
        break;
      default:
        // 'all' - no additional filtering
        break;
    }

    setFilteredBrokers(filtered);
  };

  // Update filters when search query, active filter, or topBrokers changes
  React.useEffect(() => {
    filterBrokers();
  }, [searchQuery, activeFilter, topBrokers]);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const handleSearch = () => {
    filterBrokers();
  };

  return (
    <section className="top-brokers-section">
      <div className="container">
        <div className="section-header">
          <h2>Find Your Perfect Broker</h2>
        </div>
        
        {/* Broker Search Bar */}
        <div className="broker-search-bar">
          <div className="search-container">
            <span className="material-icons">search</span>
              <input 
                type="text" 
                placeholder="Search brokers by name"
              className="broker-search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />
            <button className="broker-search-btn" onClick={handleSearch}>
              Search
            </button>
          </div>
          <div className="quick-filters">
            <button 
              className={`filter-chip ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => handleFilterClick('all')}
            >
              All Brokers
            </button>
            <button 
              className={`filter-chip ${activeFilter === 'lowSpread' ? 'active' : ''}`}
              onClick={() => handleFilterClick('lowSpread')}
            >
              Low Spread
            </button>
            <button 
              className={`filter-chip ${activeFilter === 'highLeverage' ? 'active' : ''}`}
              onClick={() => handleFilterClick('highLeverage')}
            >
              High Leverage
            </button>
            <button 
              className={`filter-chip ${activeFilter === 'lowDeposit' ? 'active' : ''}`}
              onClick={() => handleFilterClick('lowDeposit')}
            >
              Low Deposit
            </button>
            <button 
              className={`filter-chip ${activeFilter === 'regulated' ? 'active' : ''}`}
              onClick={() => handleFilterClick('regulated')}
            >
              Regulated
            </button>
          </div>
          
          {/* Search Suggestions */}
          {searchQuery.length > 0 && (
            <div className="search-suggestions">
              <p>Search suggestions:</p>
              <div className="suggestion-chips">
                <span className="suggestion-chip">Broker names: XM, FXTM, IC Markets</span>
                <span className="suggestion-chip">Regulation: FCA, ASIC, CySEC</span>
                <span className="suggestion-chip">Deposits: $5, $10, $100, $200</span>
                <span className="suggestion-chip">Spreads: 0.0, 0.1, 0.9, 1.1</span>
              </div>
            </div>
          )}
        </div>
        
        {/* Results count removed as requested */}
        
        {loading && (
          <div className="loading-state">
            <span className="material-icons">hourglass_empty</span>
            <p>Loading brokers...</p>
          </div>
        )}
        
        {error && !loading && (
          <div className="error-state">
            <span className="material-icons">error_outline</span>
            <p>Error loading brokers: {error}</p>
          </div>
        )}
        
        {!loading && !error && (
          <>
            <div className="brokers-grid">
              {filteredBrokers.slice(0, 3).map((broker) => (
                <BrokerCard key={broker.id} broker={broker} t={t} onVisitBroker={onVisitBroker} />
              ))}
            </div>
            
            {filteredBrokers.length === 0 && (
              <div className="no-results">
                <span className="material-icons">search_off</span>
                <p>No brokers found matching your criteria</p>
                <button 
                  className="clear-filters-btn"
                  onClick={() => {
                    setSearchQuery('');
                    setActiveFilter('all');
                  }}
                >
                  Clear All Filters
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

// Broker Rankings Section Component
const BrokerRankingsSection = ({ t, brokers = [], loading = false, error = null }) => {
  const [activeTab, setActiveTab] = useState('rankings');
  
  // Map API brokers to rankings format
  const mapBrokerToRanking = (broker, index) => {
    const currentYear = new Date().getFullYear();
    const foundedYear = broker.apiData?.brokerFoundedYear || null;
    let experience = '-';
    
    if (foundedYear) {
      const yearsActive = currentYear - foundedYear;
      if (yearsActive >= 20) {
        experience = 'Above 20 years';
      } else if (yearsActive >= 15) {
        experience = '15-20 years';
      } else if (yearsActive >= 10) {
        experience = '10-15 years';
      } else if (yearsActive >= 5) {
        experience = '5-10 years';
      } else {
        experience = 'Below 5 years';
      }
    }
    
    // Calculate score from rating (multiply by 2 to get score out of 10)
    // Allow 0 values - only use null if rating is null or undefined
    let score = null;
    if (broker.rating !== null && broker.rating !== undefined) {
      const ratingValue = parseFloat(broker.rating) || 0;
      score = parseFloat((ratingValue * 2).toFixed(2));
    }
    
    // Get account type from API - show actual data, not static fallback
    let accountType = null;
    if (broker.apiData?.brokerAccountType !== null && broker.apiData?.brokerAccountType !== undefined) {
      const apiAccountType = broker.apiData.brokerAccountType;
      if (apiAccountType && apiAccountType.trim() !== '') {
        accountType = apiAccountType.trim();
      }
    }
    
    // Create features from broker data
    const features = [];
    // Add platform from API data
    if (broker.apiData?.brokerTradingPlatforms && broker.apiData.brokerTradingPlatforms.trim() !== '') {
      features.push(broker.apiData.brokerTradingPlatforms.trim());
    }
    
    // Get logo text
    const getLogoText = () => {
      if (broker.apiData?.brokerName) {
        const nameParts = broker.apiData.brokerName.split(' ');
        if (nameParts.length > 0) {
          return nameParts.map(part => part[0]).join('').substring(0, 4).toUpperCase();
        }
        return broker.apiData.brokerName.substring(0, 4).toUpperCase();
      }
      return broker.logo || '-';
    };
    
    return {
      id: broker.id,
      name: broker.name || '-',
      logo: getLogoText(),
      logoUrl: broker.logoUrl || null,
      score: score,
      rank: index + 1,
      accountType: accountType,
      experience: experience,
      regulated: broker.apiData?.isBrokerVerified || false,
      isAd: false,
      features: features.slice(0, 2)
    };
  };
  
  const rankingsData = brokers.length > 0 
    ? brokers.map((broker, index) => mapBrokerToRanking(broker, index))
    : [];

  const tabs = [];

  const getRankIcon = (rank) => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return rank;
  };

  const getRankColor = (rank) => {
    if (rank === 1) return '#FFD700';
    if (rank === 2) return '#C0C0C0';
    if (rank === 3) return '#CD7F32';
    return '#8B0000';
  };

  const symbolsMini = [
    { id: 's1', symbol: 'EUR/USD', price: '1.0854', change: '+0.15%', trend: 'up' },
    { id: 's2', symbol: 'GBP/USD', price: '1.2654', change: '-0.08%', trend: 'down' },
    { id: 's3', symbol: 'XAU/USD', price: '2045.67', change: '+0.78%', trend: 'up' },
    { id: 's4', symbol: 'USD/JPY', price: '148.25', change: '+0.22%', trend: 'up' },
    { id: 's5', symbol: 'BTC/USD', price: '43567.89', change: '+2.34%', trend: 'up' }
  ];

  return (
    <section className="rankings-section">
      <div className="container">
        <div className="rankings-layout">
          <aside className="rankings-left">
            <div className="symbols-mini">
              <div className="symbols-mini-header">
                <span className="material-icons">show_chart</span>
                <h3>Market Symbols</h3>
              </div>
              <div className="symbols-list">
                {symbolsMini.map(row => (
                  <div key={row.id} className="symbol-item">
                    <div className="symbol-left">
                      <span className="symbol-name">{row.symbol}</span>
                    </div>
                    <div className="symbol-right">
                      <span className="symbol-price">{row.price}</span>
                      <span className={`symbol-change ${row.trend}`}>{row.change}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </aside>

          <div className="rankings-right">
            {tabs.length > 0 && (
              <div className="rankings-header">
                <div className="rankings-tabs">
                  {tabs.map(tab => (
                    <button
                      key={tab.id}
                      className={`ranking-tab ${activeTab === tab.id ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <span className="material-icons">{tab.icon}</span>
                      <span>{tab.label}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {loading && (
              <div className="loading-state">
                <span className="material-icons">hourglass_empty</span>
                <p>Loading rankings...</p>
              </div>
            )}
            
            {error && !loading && (
              <div className="error-state">
                <span className="material-icons">error_outline</span>
                <p>Error loading rankings: {error}</p>
              </div>
            )}
            
            {!loading && !error && (
              <div className="rankings-list">
                {rankingsData.length > 0 ? (
                  rankingsData.map((broker) => (
                    <div key={broker.id} className="ranking-card">
                      <div className="ranking-card-header">
                        <div className="broker-logo-section">
                          {broker.regulated ? (
                            <div className="regulated-badge">
                              <span>Regulated</span>
                            </div>
                          ) : (
                            <div className="non-regulated-badge">
                              <span>No Regulation</span>
                            </div>
                          )}
                          <div className={`broker-logo ${broker.logoUrl ? 'has-image' : ''}`}>
                            {broker.logoUrl ? (
                              <>
                                <img 
                                  src={broker.logoUrl} 
                                  alt={broker.name}
                                  className="broker-logo-img"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    const textSpan = e.target.parentElement.querySelector('.logo-text');
                                    if (textSpan) {
                                      textSpan.style.display = 'inline';
                                    }
                                    e.target.parentElement.classList.remove('has-image');
                                  }}
                                />
                                <span className="logo-text" style={{ display: 'none' }}>{broker.logo}</span>
                              </>
                            ) : (
                              <span className="logo-text">{broker.logo}</span>
                            )}
                          </div>
                        </div>
                        
                        <div className="broker-info">
                          <h3 className="broker-name">{broker.name}</h3>
                          <div className="broker-features">
                            {broker.features && broker.features.length > 0 ? (
                              broker.features.map((feature, index) => (
                                <span key={index} className="feature-tag">{feature}</span>
                              ))
                            ) : null}
                          </div>
                        </div>

                        <div className="score-section">
                          <div className="score-display">
                            <span className="score-number">{broker.score !== null && broker.score !== undefined ? broker.score.toFixed(2) : '-'}</span>
                            <span className="score-label">Score</span>
                          </div>
                        </div>

                        <div className="account-details">
                          {broker.accountType && (
                            <div className="account-type">
                              <span className="material-icons">account_balance</span>
                              <span>{broker.accountType}</span>
                            </div>
                          )}
                          <div className="experience">
                            <span className="material-icons">schedule</span>
                            <span>{broker.experience}</span>
                          </div>
                        </div>

                        <div className="ranking-badge">
                          {broker.isAd ? (
                            <div className="ad-badge">
                              <span>AD</span>
                            </div>
                          ) : (
                            <div 
                              className="rank-badge"
                              style={{ backgroundColor: getRankColor(broker.rank) }}
                            >
                              <span className="rank-icon">{getRankIcon(broker.rank)}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-results">
                    <span className="material-icons">info_outline</span>
                    <p>No rankings available</p>
                  </div>
                )}
              </div>
            )}

            <div className="rankings-footer">
              <button className="view-all-rankings-btn">
                <span className="material-icons">list</span>
                View All Rankings
              </button>
              <button className="ranking-methodology-btn">
                <span className="material-icons">info</span>
                Ranking Methodology
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Broker Inquiry Section Component
const BrokerInquirySection = ({ t }) => (
  <section className="broker-inquiry-section">
    <div className="container">
      <div className="inquiry-content">
        <div className="inquiry-text">
          <h2>{t.inquiryTitle}</h2>
          <p>{t.inquiryText}</p>
          <ul className="inquiry-features">
            <li>
              <span className="material-icons">verified</span>
              <span>{t.regulation}</span>
            </li>
            <li>
              <span className="material-icons">trending_down</span>
              <span>{t.spreads}</span>
            </li>
            <li>
              <span className="material-icons">account_balance_wallet</span>
              <span>{t.deposits}</span>
            </li>
            <li>
              <span className="material-icons">support_agent</span>
              <span>{t.support}</span>
            </li>
            <li>
              <span className="material-icons">speed</span>
              <span>{t.speed}</span>
            </li>
            <li>
              <span className="material-icons">security</span>
              <span>{t.safety}</span>
            </li>
          </ul>
          <p>{t.inquiryText2}</p>
        </div>
        <div className="inquiry-visual">
          <div className="inquiry-image">
            <span className="material-icons">analytics</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// Search Section Component
const SearchSection = ({ t }) => {
  return (
    <section className="search-section">
      <div className="container">
        <div className="search-content">
          <h2>{t.searchTitle}</h2>
          <p>{t.searchSubtitle}</p>
          <div className="main-search-box">
            <div className="search-input-group">
              <span className="material-icons">search</span>
              <input 
                type="text" 
                placeholder="Search brokers by name"
                className="main-search-input"
              />
              <button className="main-search-btn">
                <span className="material-icons">search</span>
                {t.searchBrokers}
              </button>
            </div>
            <div className="search-filters">
              <button className="filter-btn active">{t.allBrokers}</button>
              <button className="filter-btn">{t.lowSpread}</button>
              <button className="filter-btn">{t.highLeverage}</button>
              <button className="filter-btn">{t.lowDeposit}</button>
              <button className="filter-btn">{t.regulated}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer Component
const Footer = ({ t }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-brand">
              <div className="footer-logo">
                <img
                  className="footer-logo-img"
                  src={`${process.env.PUBLIC_URL}/forexumpire_logo.png`}
                  alt="ForexUmpire"
                />
              </div>
              <p className="footer-description">
                Your trusted partner in forex trading. We provide comprehensive broker reviews, 
                market analysis, and educational resources to help you make informed trading decisions.
              </p>
              <div className="social-links">
                <a href="#" className="social-link">
                  <span className="material-icons">facebook</span>
                </a>
                <a href="#" className="social-link">
                  <span className="material-icons">twitter</span>
                </a>
                <a href="#" className="social-link">
                  <span className="material-icons">linkedin</span>
                </a>
                <a href="#" className="social-link">
                  <span className="material-icons">youtube</span>
                </a>
                <a href="#" className="social-link">
                  <span className="material-icons">telegram</span>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">{t.home}</a></li>
              <li><a href="#markets">{t.markets}</a></li>
              <li><a href="#brokers">{t.brokers}</a></li>
              <li><a href="#reviews">{t.reviews}</a></li>
              <li><a href="#education">{t.education}</a></li>
              <li><a href="#news">{t.news}</a></li>
              <li><a href="#tools">{t.tools}</a></li>
            </ul>
          </div>

          {/* Trading Resources */}
          <div className="footer-section">
            <h4>Trading Resources</h4>
            <ul className="footer-links">
              <li><a href="#forex-guide">Forex Trading Guide</a></li>
              <li><a href="#risk-management">Risk Management</a></li>
              <li><a href="#technical-analysis">Technical Analysis</a></li>
              <li><a href="#fundamental-analysis">Fundamental Analysis</a></li>
              <li><a href="#trading-strategies">Trading Strategies</a></li>
              <li><a href="#economic-calendar">Economic Calendar</a></li>
              <li><a href="#trading-signals">Trading Signals</a></li>
            </ul>
          </div>

          {/* Broker Categories */}
          <div className="footer-section">
            <h4>Broker Categories</h4>
            <ul className="footer-links">
              <li><a href="#regulated-brokers">Regulated Brokers</a></li>
              <li><a href="#low-spread-brokers">Low Spread Brokers</a></li>
              <li><a href="#high-leverage-brokers">High Leverage Brokers</a></li>
              <li><a href="#low-deposit-brokers">Low Deposit Brokers</a></li>
              <li><a href="#ecn-brokers">ECN Brokers</a></li>
              <li><a href="#islamic-accounts">Islamic Accounts</a></li>
              <li><a href="#demo-accounts">Demo Accounts</a></li>
            </ul>
          </div>

          {/* Support & Legal */}
          <div className="footer-section">
            <h4>Support & Legal</h4>
            <ul className="footer-links">
              <li><a href="#contact">{t.contact}</a></li>
              <li><a href="#about">{t.about}</a></li>
              <li><a href="#privacy-policy">Privacy Policy</a></li>
              <li><a href="#terms-conditions">Terms & Conditions</a></li>
              <li><a href="#disclaimer">Disclaimer</a></li>
              <li><a href="#risk-warning">Risk Warning</a></li>
              <li><a href="#sitemap">Sitemap</a></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2024 ForexUmpire. All rights reserved.</p>
              <p>Forex trading involves substantial risk and may not be suitable for all investors.</p>
            </div>
            <div className="footer-badges">
              <div className="badge">
                <span className="material-icons">security</span>
                <span>SSL Secured</span>
              </div>
              <div className="badge">
                <span className="material-icons">verified</span>
                <span>Trusted Reviews</span>
              </div>
              <div className="badge">
                <span className="material-icons">update</span>
                <span>Daily Updates</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Newsletter Section Component (separate, above footer)
const NewsletterSection = () => {
  return (
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-content">
          <div className="newsletter-text">
            <h3>Stay Updated with Market News</h3>
            <p>Get the latest forex news, broker updates, and trading insights delivered to your inbox.</p>
          </div>
          <div className="newsletter-form">
            <div className="email-input-group">
              <span className="material-icons">email</span>
              <input 
                type="email" 
                placeholder="Enter your email address"
                className="newsletter-input"
              />
              <button className="newsletter-btn">
                <span className="material-icons">send</span>
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// News Section Component
const NewsSection = ({ t }) => {
  const newsData = [
    {
      id: 1,
      title: "Federal Reserve Signals Potential Rate Cuts in 2024",
      summary: "The Federal Reserve hints at possible interest rate reductions next year, impacting USD strength and forex markets globally.",
      category: "Central Banks",
      time: "2 hours ago",
      image: "trending_up",
      impact: "high"
    },
    {
      id: 2,
      title: "EUR/USD Hits 3-Month High Amid ECB Policy Changes",
      summary: "European Central Bank maintains dovish stance as EUR/USD reaches highest levels since September, with traders eyeing 1.0900 resistance.",
      category: "Forex",
      time: "4 hours ago",
      image: "currency_exchange",
      impact: "medium"
    },
    {
      id: 3,
      title: "Bitcoin Surges Past $44,000 as Institutional Adoption Grows",
      summary: "Major corporations announce Bitcoin treasury holdings, driving cryptocurrency prices higher and increasing mainstream adoption.",
      category: "Cryptocurrency",
      time: "6 hours ago",
      image: "currency_bitcoin",
      impact: "high"
    },
    {
      id: 4,
      title: "Gold Prices Rise on Safe-Haven Demand",
      summary: "Geopolitical tensions and economic uncertainty drive investors toward precious metals, pushing gold above $2,040 per ounce.",
      category: "Commodities",
      time: "8 hours ago",
      image: "inventory",
      impact: "medium"
    },
    {
      id: 5,
      title: "UK Inflation Data Shows Surprise Drop",
      summary: "British inflation falls more than expected, strengthening the case for Bank of England rate cuts and boosting GBP sentiment.",
      category: "Economic Data",
      time: "10 hours ago",
      image: "analytics",
      impact: "medium"
    },
    {
      id: 6,
      title: "Oil Prices Volatile Amid OPEC+ Production Cuts",
      summary: "Crude oil futures fluctuate as OPEC+ announces extended production cuts, with WTI trading around $78 per barrel.",
      category: "Commodities",
      time: "12 hours ago",
      image: "local_gas_station",
      impact: "low"
    }
  ];

  const getImpactColor = (impact) => {
    switch (impact) {
      case 'high': return '#ef4444';
      case 'medium': return '#f59e0b';
      case 'low': return '#10b981';
      default: return '#64748b';
    }
  };

  return (
    <section className="news-section">
      <div className="container">
        <div className="news-header">
          <h2>Latest Market News</h2>
          <p>Stay updated with the latest forex, crypto, and financial market developments</p>
        </div>
        
        <div className="news-grid">
          {newsData.map((news) => (
            <article key={news.id} className="news-card">
              <div className="news-card-header">
                <div className="news-category">
                  <span className="material-icons">{news.image}</span>
                  <span>{news.category}</span>
                </div>
                <div className="news-time">{news.time}</div>
              </div>
              
              <div className="news-content">
                <h3>{news.title}</h3>
                <p>{news.summary}</p>
              </div>
              
              <div className="news-card-footer">
                <div className="news-impact">
                  <span 
                    className="impact-dot" 
                    style={{ backgroundColor: getImpactColor(news.impact) }}
                  ></span>
                  <span className="impact-text">
                    {news.impact.charAt(0).toUpperCase() + news.impact.slice(1)} Impact
                  </span>
                </div>
                <button className="read-more-btn">
                  <span className="material-icons">arrow_forward</span>
                  Read More
                </button>
              </div>
            </article>
          ))}
        </div>
        
        <div className="news-actions">
          <button className="view-all-news-btn">
            <span className="material-icons">article</span>
            View All News
          </button>
          <button className="news-alerts-btn">
            <span className="material-icons">notifications</span>
            Set News Alerts
          </button>
        </div>
      </div>
    </section>
  );
};

// Education Section Component
const EducationSection = ({ t }) => {
  const topics = [
    { icon: 'school', title: 'Forex Basics', desc: 'Learn currency pairs, pips, lots and market structure.' },
    { icon: 'insights', title: 'Technical Analysis', desc: 'Trends, S/R, indicators, candlestick patterns.' },
    { icon: 'analytics', title: 'Fundamental Analysis', desc: 'Rates, inflation, jobs data, central banks.' },
    { icon: 'security', title: 'Risk Management', desc: 'Position sizing, R:R, psychology and discipline.' },
    { icon: 'devices', title: 'Platforms & Tools', desc: 'MT4/MT5, web platforms, mobile trading.' },
    { icon: 'collections_bookmark', title: 'Strategies', desc: 'Scalping, swing, breakouts, news trading.' }
  ];

  return (
    <section className="education-section">
      <div className="container">
        <div className="section-header">
          <h2>{t.education}</h2>
          <p>Start from basics and level up your trading skills step by step.</p>
        </div>
        <div className="features-grid">
          {topics.map((topic, idx) => (
            <div key={idx} className="feature-item">
              <span className="material-icons">{topic.icon}</span>
              <div>
                <h4>{topic.title}</h4>
                <p>{topic.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Tools Section Component
const ToolsSection = ({ t }) => {
  const tools = [
    { icon: 'event_note', title: 'Economic Calendar', desc: 'Track key macro events that move markets.' },
    { icon: 'query_stats', title: 'Technical Screener', desc: 'Find pairs with strong technical signals.' },
    { icon: 'calculate', title: 'Position Size Calculator', desc: 'Size trades by risk and stop distance.' },
    { icon: 'timeline', title: 'Trend Dashboard', desc: 'Multi-timeframe trend snapshot.' },
    { icon: 'savings', title: 'Pip & Margin Calculator', desc: 'Work out pip values and margin needs.' },
    { icon: 'notifications_active', title: 'Price Alerts', desc: 'Get notified when price hits your level.' }
  ];

  return (
    <section className="tools-section">
      <div className="container">
        <div className="section-header">
          <h2>{t.tools}</h2>
          <p>Practical utilities to plan, analyze, and execute your trades efficiently.</p>
        </div>
        <div className="features-grid">
          {tools.map((tool, idx) => (
            <div key={idx} className="feature-item">
              <span className="material-icons">{tool.icon}</span>
              <div>
                <h4>{tool.title}</h4>
                <p>{tool.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Ads Section Component
const AdsSection = () => {
  const placeholders = new Array(6).fill(null);

  return (
    <section className="ads-section">
      <div className="container">
        <div className="ads-grid">
          {placeholders.map((_, idx) => (
            <div key={idx} className="ad-card">
              <div className="ad-placeholder">
                <span className="material-icons">image_not_supported</span>
                <span className="ad-placeholder-text">No Ads</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Broker Details Page Component
const BrokerDetailsPage = ({ broker, t, onBackToHome, loading = false, error = null }) => {
  if (loading) {
    return (
      <div className="broker-details-layout">
        <div className="container">
          <div className="loading-state">
            <span className="material-icons">hourglass_empty</span>
            <p>Loading broker details...</p>
          </div>
        </div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="broker-details-layout">
        <div className="container">
          <div className="error-state">
            <span className="material-icons">error_outline</span>
            <p>Error loading broker: {error}</p>
            <button className="back-btn" onClick={onBackToHome} style={{ marginTop: '20px' }}>
              <span className="material-icons">arrow_back</span>
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  if (!broker) {
    return (
      <div className="broker-details-layout">
        <div className="container">
          <div className="error-state">
            <span className="material-icons">error_outline</span>
            <p>Broker not found</p>
            <button className="back-btn" onClick={onBackToHome} style={{ marginTop: '20px' }}>
              <span className="material-icons">arrow_back</span>
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="broker-details-layout">
      {/* Main Content */}
      <div className="broker-details-main">
        <div className="container">
          {/* Back Button */}
          <div className="back-button-container">
            <button className="back-btn" onClick={onBackToHome}>
              <span className="material-icons">arrow_back</span>
              Back to Brokers
            </button>
          </div>

                  {/* Enhanced Broker Header */}
        <div className="broker-header-detail">
          <div className="broker-logo-section">
            <div className={`broker-logo-large ${broker.logoUrl ? 'has-image' : ''}`}>
              {broker.logoUrl ? (
                <>
                  <img 
                    src={broker.logoUrl} 
                    alt={broker.name}
                    className="broker-logo-img-large"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const textSpan = e.target.parentElement.querySelector('span');
                      if (textSpan) {
                        textSpan.style.display = 'inline';
                      }
                      e.target.parentElement.classList.remove('has-image');
                    }}
                  />
                  <span style={{ display: 'none' }}>{broker.logo}</span>
                </>
              ) : (
                <span>{broker.logo}</span>
              )}
              {/* Regulation Banner - Top Left */}
              {broker.regulated ? (
                <div className="regulation-banner">Regulated</div>
              ) : (
                <div className="no-regulation-banner">No Regulation</div>
              )}
              {/* License/No License Stamp - Bottom Right */}
              {broker.regulated ? (
                <div className="license-stamp">License</div>
              ) : (
                <div className="no-license-stamp">No License</div>
              )}
            </div>
          </div>
          
          <div className="broker-info-detail">
            <div className="broker-title-section">
              <h1>{broker.name}</h1>
              <div className="broker-subtitle">
                <span className="country-flag">🇺🇸</span>
                <span className="country-name">United States</span>
                <span className="separator">•</span>
                <span className="established">Est. 2005</span>
                <span className="separator">•</span>
                <span className="years-active">19+ Years</span>
              </div>
            </div>
            
            <div className="broker-rating-detail">
              <div className="rating-main">
                <div className="stars-large">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className={`star-large ${i < Math.floor(broker.rating) ? 'filled' : ''}`}>
                      ★
                    </span>
                  ))}
                </div>
                <span className="rating-text-large">{broker.rating}/5</span>
                <span className="reviews-count-large">({broker.reviews.toLocaleString()} {t.reviews})</span>
              </div>
              <div className="rating-breakdown">
                <div className="rating-item">
                  <span className="rating-label">Trust Score</span>
                  <span className="rating-value">95/100</span>
                </div>
                <div className="rating-item">
                  <span className="rating-label">Platform</span>
                  <span className="rating-value">92/100</span>
                </div>
                <div className="rating-item">
                  <span className="rating-label">Fees</span>
                  <span className="rating-value">88/100</span>
                </div>
              </div>
            </div>
            
            <div className="broker-rank-detail">
              <span className="rank-number">#{broker.rank}</span>
              <span className="rank-title">Top Rated Broker</span>
              <span className="rank-category">Forex & CFDs</span>
            </div>
          </div>
          
          <div className="broker-quick-stats">
            <div className="quick-stat">
              <span className="stat-icon material-icons">people</span>
              <div className="stat-content">
                <span className="stat-value">2.5M+</span>
                <span className="stat-label">Active Traders</span>
              </div>
            </div>
            <div className="quick-stat">
              <span className="stat-icon material-icons">public</span>
              <div className="stat-content">
                <span className="stat-value">150+</span>
                <span className="stat-label">Countries</span>
              </div>
            </div>
            <div className="quick-stat">
              <span className="stat-icon material-icons">account_balance</span>
              <div className="stat-content">
                <span className="stat-value">$50B+</span>
                <span className="stat-label">Assets Under Management</span>
              </div>
            </div>
            <div className="quick-stat">
              <span className="stat-icon material-icons">speed</span>
              <div className="stat-content">
                <span className="stat-value">0.1s</span>
                <span className="stat-label">Execution Speed</span>
              </div>
            </div>
          </div>
        </div>

                  {/* Broker Stats Grid */}
        <div className="broker-stats-grid">
          <div className="stat-card">
            <span className="material-icons">trending_down</span>
            <h3>Spread</h3>
            <p className="stat-value">{broker.spread} {t.pips}</p>
            <p className="stat-label">Starting from</p>
          </div>
          <div className="stat-card">
            <span className="material-icons">account_balance_wallet</span>
            <h3>Min Deposit</h3>
            <p className="stat-value">{broker.minDeposit}</p>
            <p className="stat-label">To start trading</p>
          </div>
          <div className="stat-card">
            <span className="material-icons">verified</span>
            <h3>Regulation</h3>
            <p className="stat-value">{broker.regulation}</p>
            <p className="stat-label">Licensed & Secure</p>
          </div>
          <div className="stat-card">
            <span className="material-icons">star</span>
            <h3>Rating</h3>
            <p className="stat-value">{broker.rating}/5</p>
            <p className="stat-label">User Satisfaction</p>
          </div>
        </div>

        {/* Trading Performance Charts */}
        <div className="charts-section">
          <h2>Trading Performance & Market Analysis</h2>
          
          {/* Main Chart */}
          <div className="performance-chart main-chart">
            <div className="chart-header">
              <div className="chart-title">
                <span className="material-icons">show_chart</span>
                <span>EUR/USD Performance (Last 30 Days)</span>
              </div>
              <div className="chart-controls">
                <button className="chart-period active">1M</button>
                <button className="chart-period">3M</button>
                <button className="chart-period">6M</button>
                <button className="chart-period">1Y</button>
              </div>
            </div>
            <div className="chart-container">
              <div className="chart-placeholder">
                <span className="material-icons">analytics</span>
                <p>Interactive Trading Chart</p>
                <span className="chart-note">Chart data would be integrated here</span>
              </div>
            </div>
            <div className="chart-stats">
              <div className="chart-stat">
                <span className="stat-label">Current Price</span>
                <span className="stat-value">1.0854</span>
              </div>
              <div className="chart-stat">
                <span className="stat-label">24h Change</span>
                <span className="stat-value positive">+0.15%</span>
              </div>
              <div className="chart-stat">
                <span className="stat-label">24h High</span>
                <span className="stat-value">1.0872</span>
              </div>
              <div className="chart-stat">
                <span className="stat-label">24h Low</span>
                <span className="stat-value">1.0831</span>
              </div>
            </div>
          </div>

          {/* Mini Charts Grid */}
          <div className="mini-charts-grid">
            <div className="mini-chart">
              <div className="mini-chart-header">
                <h4>GBP/USD</h4>
                <span className="trend-indicator positive">↗</span>
              </div>
              <div className="mini-chart-container">
                <div className="mini-chart-placeholder">
                  <span className="material-icons">trending_up</span>
                </div>
              </div>
              <div className="mini-chart-data">
                <span className="price">1.2654</span>
                <span className="change positive">+0.08%</span>
              </div>
            </div>

            <div className="mini-chart">
              <div className="mini-chart-header">
                <h4>USD/JPY</h4>
                <span className="trend-indicator positive">↗</span>
              </div>
              <div className="mini-chart-container">
                <div className="mini-chart-placeholder">
                  <span className="material-icons">trending_up</span>
                </div>
              </div>
              <div className="mini-chart-data">
                <span className="price">148.25</span>
                <span className="change positive">+0.22%</span>
              </div>
            </div>

            <div className="mini-chart">
              <div className="mini-chart-header">
                <h4>USD/CHF</h4>
                <span className="trend-indicator negative">↘</span>
              </div>
              <div className="mini-chart-container">
                <div className="mini-chart-placeholder">
                  <span className="material-icons">trending_down</span>
                </div>
              </div>
              <div className="mini-chart-data">
                <span className="price">0.8542</span>
                <span className="change negative">-0.12%</span>
              </div>
            </div>

            <div className="mini-chart">
              <div className="mini-chart-header">
                <h4>AUD/USD</h4>
                <span className="trend-indicator positive">↗</span>
              </div>
              <div className="mini-chart-container">
                <div className="mini-chart-placeholder">
                  <span className="material-icons">trending_up</span>
                </div>
              </div>
              <div className="mini-chart-data">
                <span className="price">0.6548</span>
                <span className="change positive">+0.18%</span>
              </div>
            </div>
          </div>

          {/* Market Sentiment Chart */}
          <div className="market-sentiment-chart">
            <h3>Market Sentiment Analysis</h3>
            <div className="sentiment-container">
              <div className="sentiment-item">
                <div className="sentiment-label">
                  <span>Bullish</span>
                  <span>65%</span>
                </div>
                <div className="sentiment-bar">
                  <div className="sentiment-fill bullish" style={{width: '65%'}}></div>
                </div>
              </div>
              <div className="sentiment-item">
                <div className="sentiment-label">
                  <span>Neutral</span>
                  <span>25%</span>
                </div>
                <div className="sentiment-bar">
                  <div className="sentiment-fill neutral" style={{width: '25%'}}></div>
                </div>
              </div>
              <div className="sentiment-item">
                <div className="sentiment-label">
                  <span>Bearish</span>
                  <span>10%</span>
                </div>
                <div className="sentiment-bar">
                  <div className="sentiment-fill bearish" style={{width: '10%'}}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Market Data Dashboard */}
        <div className="market-data-dashboard">
          <h2>Live Market Data</h2>
          <div className="market-data-grid">
            <div className="market-data-card">
              <div className="data-header">
                <span className="material-icons">currency_exchange</span>
                <h4>Major Pairs</h4>
              </div>
              <div className="data-content">
                <div className="currency-pair">
                  <span className="pair-name">EUR/USD</span>
                  <span className="pair-price">1.0854</span>
                  <span className="pair-change positive">+0.15%</span>
                </div>
                <div className="currency-pair">
                  <span className="pair-name">GBP/USD</span>
                  <span className="pair-price">1.2654</span>
                  <span className="pair-change positive">+0.08%</span>
                </div>
                <div className="currency-pair">
                  <span className="pair-name">USD/JPY</span>
                  <span className="pair-price">148.25</span>
                  <span className="pair-change positive">+0.22%</span>
                </div>
              </div>
            </div>

            <div className="market-data-card">
              <div className="data-header">
                <span className="material-icons">trending_up</span>
                <h4>Indices</h4>
              </div>
              <div className="data-content">
                <div className="index-item">
                  <span className="index-name">S&P 500</span>
                  <span className="index-price">4,567.89</span>
                  <span className="index-change positive">+0.45%</span>
                </div>
                <div className="index-item">
                  <span className="index-name">NASDAQ</span>
                  <span className="index-price">14,234.56</span>
                  <span className="index-change positive">+0.67%</span>
                </div>
                <div className="index-item">
                  <span className="index-name">DOW</span>
                  <span className="index-price">35,678.12</span>
                  <span className="index-change negative">-0.12%</span>
                </div>
              </div>
            </div>

            <div className="market-data-card">
              <div className="data-header">
                <span className="material-icons">local_gas_station</span>
                <h4>Commodities</h4>
              </div>
              <div className="data-content">
                <div className="commodity-item">
                  <span className="commodity-name">Gold</span>
                  <span className="commodity-price">$2,045.67</span>
                  <span className="commodity-change positive">+0.78%</span>
                </div>
                <div className="commodity-item">
                  <span className="commodity-name">Oil (WTI)</span>
                  <span className="commodity-price">$78.45</span>
                  <span className="commodity-change negative">-1.23%</span>
                </div>
                <div className="commodity-item">
                  <span className="commodity-name">Silver</span>
                  <span className="commodity-price">$24.56</span>
                  <span className="commodity-change positive">+0.45%</span>
                </div>
              </div>
            </div>

            <div className="market-data-card">
              <div className="data-header">
                <span className="material-icons">currency_bitcoin</span>
                <h4>Crypto</h4>
              </div>
              <div className="data-content">
                <div className="crypto-item">
                  <span className="crypto-name">Bitcoin</span>
                  <span className="crypto-price">$43,567.89</span>
                  <span className="crypto-change positive">+2.34%</span>
                </div>
                <div className="crypto-item">
                  <span className="crypto-name">Ethereum</span>
                  <span className="crypto-price">$2,345.67</span>
                  <span className="crypto-change positive">+1.87%</span>
                </div>
                <div className="crypto-item">
                  <span className="crypto-name">BNB</span>
                  <span className="crypto-price">$234.56</span>
                  <span className="crypto-change negative">-0.45%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Broker Comparison Table */}
        <div className="broker-comparison-section">
          <h2>Broker Comparison</h2>
          <div className="comparison-table">
            <table>
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>{broker.name}</th>
                  <th>FXTM</th>
                  <th>IC Markets</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Spread (EUR/USD)</td>
                  <td className="highlight">{broker.spread} {t.pips}</td>
                  <td>0.1 {t.pips}</td>
                  <td>0.0 {t.pips}</td>
                </tr>
                <tr>
                  <td>Min Deposit</td>
                  <td className="highlight">{broker.minDeposit}</td>
                  <td>$10</td>
                  <td>$200</td>
                </tr>
                <tr>
                  <td>Regulation</td>
                  <td className="highlight">{broker.regulation}</td>
                  <td>FCA, CySEC</td>
                  <td>ASIC, CySEC</td>
                </tr>
                <tr>
                  <td>Rating</td>
                  <td className="highlight">{broker.rating}/5</td>
                  <td>4.7/5</td>
                  <td>4.9/5</td>
                </tr>
                <tr>
                  <td>Platforms</td>
                  <td className="highlight">MT4, MT5, Mobile</td>
                  <td>MT4, MT5, Mobile</td>
                  <td>MT4, MT5, Mobile</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

          {/* Detailed Information */}
          <div className="broker-details-content">
            <div className="detail-section">
              <h2>About {broker.name}</h2>
              <p>{broker.name} is a leading forex broker known for its competitive spreads, reliable trading platform, and excellent customer service. With strong regulation and years of experience in the market, {broker.name} provides traders with a secure and professional trading environment.</p>
              
              <div className="broker-highlights">
                <div className="highlight-item">
                  <span className="material-icons">calendar_today</span>
                  <div>
                    <h4>Established</h4>
                    <p>2005 - 18+ years experience</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <span className="material-icons">public</span>
                  <div>
                    <h4>Global Presence</h4>
                    <p>150+ countries served</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <span className="material-icons">people</span>
                  <div>
                    <h4>Active Traders</h4>
                    <p>2.5M+ registered users</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="detail-section">
              <h2>Key Features</h2>
              <div className="features-grid">
                <div className="feature-item">
                  <span className="material-icons">speed</span>
                  <span>Fast Execution</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">security</span>
                  <span>Fund Security</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">support_agent</span>
                  <span>24/7 Support</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">devices</span>
                  <span>Multi-Platform</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">trending_up</span>
                  <span>Advanced Charts</span>
                </div>
                <div className="feature-item">
                  <span className="material-icons">school</span>
                  <span>Free Education</span>
                </div>
              </div>
            </div>

            <div className="detail-section">
              <h2>Trading Instruments</h2>
              <div className="instruments-grid">
                <span className="instrument-chip">Forex (50+ pairs)</span>
                <span className="instrument-chip">Stocks (1000+)</span>
                <span className="instrument-chip">Commodities (20+)</span>
                <span className="instrument-chip">Indices (15+)</span>
                <span className="instrument-chip">Crypto (30+)</span>
                <span className="instrument-chip">ETFs (200+)</span>
              </div>
            </div>

            <div className="detail-section">
              <h2>Platforms & Apps</h2>
              <div className="platforms-grid">
                {broker.apiData?.brokerTradingPlatforms && broker.apiData.brokerTradingPlatforms.trim() !== '' ? (
                  <div className="platform-item">
                    <span className="material-icons">computer</span>
                    <span>{broker.apiData.brokerTradingPlatforms.trim()}</span>
                  </div>
                ) : null}
              </div>
            </div>

            {/* Trading Conditions */}
            <div className="detail-section">
              <h2>Trading Conditions</h2>
              <div className="trading-conditions-grid">
                <div className="condition-item">
                  <h4>Account Types</h4>
                  <div className="account-types">
                    <span className="account-type">Standard</span>
                    <span className="account-type">Premium</span>
                    <span className="account-type">VIP</span>
                  </div>
                </div>
                <div className="condition-item">
                  <h4>Leverage</h4>
                  <p>Up to 1:500</p>
                </div>
                <div className="condition-item">
                  <h4>Commission</h4>
                  <p>From $3.5 per lot</p>
                </div>
                <div className="condition-item">
                  <h4>Swap</h4>
                  <p>Variable rates</p>
                </div>
              </div>
            </div>

            {/* Deposit & Withdrawal */}
            <div className="detail-section">
              <h2>Deposit & Withdrawal</h2>
              <div className="payment-methods">
                <div className="payment-category">
                  <h4>Bank Transfer</h4>
                  <p>Processing: 1-3 business days</p>
                  <p>Fee: Free</p>
                </div>
                <div className="payment-category">
                  <h4>Credit/Debit Card</h4>
                  <p>Processing: Instant</p>
                  <p>Fee: 2.5%</p>
                </div>
                <div className="payment-category">
                  <h4>E-Wallets</h4>
                  <p>Processing: Instant</p>
                  <p>Fee: 1.5%</p>
                </div>
                <div className="payment-category">
                  <h4>Cryptocurrency</h4>
                  <p>Processing: 10-30 minutes</p>
                  <p>Fee: 0.5%</p>
                </div>
              </div>
            </div>

            {/* Customer Support */}
            <div className="detail-section">
              <h2>Customer Support</h2>
              <div className="support-features">
                <div className="support-item">
                  <span className="material-icons">schedule</span>
                  <div>
                    <h4>24/7 Support</h4>
                    <p>Available round the clock</p>
                  </div>
                </div>
                <div className="support-item">
                  <span className="material-icons">language</span>
                  <div>
                    <h4>Multi-Language</h4>
                    <p>English, Spanish, French, German, Arabic</p>
                  </div>
                </div>
                <div className="support-item">
                  <span className="material-icons">chat</span>
                  <div>
                    <h4>Live Chat</h4>
                    <p>Instant response within 2 minutes</p>
                  </div>
                </div>
                <div className="support-item">
                  <span className="material-icons">phone</span>
                  <div>
                    <h4>Phone Support</h4>
                    <p>Dedicated support lines</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Economic Calendar */}
            <div className="detail-section">
              <h2>Economic Calendar</h2>
              <div className="economic-calendar">
                <div className="calendar-header">
                  <h4>Today's Key Events</h4>
                  <span className="date">December 15, 2024</span>
                </div>
                <div className="calendar-events">
                  <div className="event-item high-impact">
                    <div className="event-time">14:30 GMT</div>
                    <div className="event-details">
                      <div className="event-title">US CPI Data</div>
                      <div className="event-country">United States</div>
                    </div>
                    <div className="event-impact">High Impact</div>
                  </div>
                  <div className="event-item medium-impact">
                    <div className="event-time">15:00 GMT</div>
                    <div className="event-details">
                      <div className="event-title">ECB President Speech</div>
                      <div className="event-country">European Union</div>
                    </div>
                    <div className="event-impact">Medium Impact</div>
                  </div>
                  <div className="event-item low-impact">
                    <div className="event-time">16:00 GMT</div>
                    <div className="event-details">
                      <div className="event-title">UK Employment Data</div>
                      <div className="event-country">United Kingdom</div>
                    </div>
                    <div className="event-impact">Low Impact</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Trading Signals */}
            <div className="detail-section">
              <h2>Latest Trading Signals</h2>
              <div className="trading-signals">
                <div className="signal-item buy">
                  <div className="signal-header">
                    <span className="signal-type buy">BUY</span>
                    <span className="signal-pair">EUR/USD</span>
                    <span className="signal-time">2 hours ago</span>
                  </div>
                  <div className="signal-details">
                    <p>Strong support at 1.0830, target 1.0900</p>
                    <div className="signal-stats">
                      <span>Entry: 1.0854</span>
                      <span>Stop Loss: 1.0800</span>
                      <span>Take Profit: 1.0900</span>
                    </div>
                  </div>
                </div>
                <div className="signal-item sell">
                  <div className="signal-header">
                    <span className="signal-type sell">SELL</span>
                    <span className="signal-pair">GBP/USD</span>
                    <span className="signal-time">4 hours ago</span>
                  </div>
                  <div className="signal-details">
                    <p>Resistance at 1.2700, target 1.2600</p>
                    <div className="signal-stats">
                      <span>Entry: 1.2654</span>
                      <span>Stop Loss: 1.2700</span>
                      <span>Take Profit: 1.2600</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="broker-actions-detail">
            <button className="btn-primary">
              <span className="material-icons">open_in_new</span>
              Visit Official Website
            </button>
            <button className="btn-secondary">
              <span className="material-icons">rate_review</span>
              Read Full Review
            </button>
            <button className="btn-tertiary">
              <span className="material-icons">compare</span>
              Compare with Others
            </button>
          </div>
        </div>
      </div>

      {/* Right Sidebar - Ads & Related Content */}
      <div className="broker-details-sidebar">
        {/* Featured Ad */}
        <div className="sidebar-ad featured-ad">
          <div className="ad-header">
            <span className="material-icons">campaign</span>
            <span>Sponsored</span>
          </div>
          <h3>Start Trading Today!</h3>
          <p>Get up to $1000 bonus on your first deposit</p>
          <button className="ad-cta">Claim Bonus</button>
        </div>

        {/* Related Brokers */}
        <div className="sidebar-section">
          <h3>Similar Brokers</h3>
          <div className="related-brokers">
            <div className="related-broker">
              <div className="related-logo">FXTM</div>
              <div className="related-info">
                <h4>FXTM</h4>
                <p>4.7/5 • $10 min</p>
              </div>
            </div>
            <div className="related-broker">
              <div className="related-logo">IC</div>
              <div className="related-info">
                <h4>IC Markets</h4>
                <p>4.9/5 • $200 min</p>
              </div>
            </div>
            <div className="related-broker">
              <div className="related-logo">PS</div>
              <div className="related-info">
                <h4>Pepperstone</h4>
                <p>4.6/5 • $200 min</p>
              </div>
            </div>
          </div>
        </div>

        {/* Trading Education Ad */}
        <div className="sidebar-ad education-ad">
          <div className="ad-header">
            <span className="material-icons">school</span>
            <span>Learn Trading</span>
          </div>
          <h3>Free Trading Course</h3>
          <p>Master forex trading in 30 days</p>
          <ul className="course-features">
            <li>✓ 50+ Video Lessons</li>
            <li>✓ Live Trading Sessions</li>
            <li>✓ Expert Support</li>
          </ul>
          <button className="ad-cta">Start Learning</button>
        </div>

        {/* Market News */}
        <div className="sidebar-section">
          <h3>Latest Market News</h3>
          <div className="news-items">
            <div className="news-item">
              <h4>USD Strengthens Against Major Currencies</h4>
              <p>Federal Reserve signals potential rate hikes...</p>
              <span className="news-time">2 hours ago</span>
            </div>
            <div className="news-item">
              <h4>EUR/USD Hits 3-Month Low</h4>
              <p>European Central Bank maintains dovish stance...</p>
              <span className="news-time">5 hours ago</span>
            </div>
          </div>
        </div>

        {/* Trading Tools Ad */}
        <div className="sidebar-ad tools-ad">
          <div className="ad-header">
            <span className="material-icons">build</span>
            <span>Premium Tools</span>
          </div>
          <h3>Advanced Trading Tools</h3>
          <p>Get professional-grade analysis tools</p>
          <div className="tools-list">
            <span className="tool-chip">Economic Calendar</span>
            <span className="tool-chip">Technical Analysis</span>
            <span className="tool-chip">Risk Calculator</span>
          </div>
          <button className="ad-cta">Get Tools</button>
        </div>
      </div>
    </div>
  );
};

// Stock Market Slider Component
const StockMarketSlider = ({ stockTicker }) => (
  <div className="stock-slider-container">
    <div className="stock-slider">
      {stockTicker.map((stock, index) => (
        <div key={index} className="stock-item">
          <span className="stock-symbol">{stock.symbol}</span>
          <span className={`stock-price ${stock.trend}`}>{stock.price}</span>
          <span className={`stock-change ${stock.trend}`}>{stock.change}</span>
        </div>
      ))}
      {/* Duplicate items for seamless loop */}
      {stockTicker.map((stock, index) => (
        <div key={`duplicate-${index}`} className="stock-item">
          <span className="stock-symbol">{stock.symbol}</span>
          <span className={`stock-price ${stock.trend}`}>{stock.price}</span>
          <span className={`stock-change ${stock.trend}`}>{stock.change}</span>
        </div>
      ))}
    </div>
  </div>
);

// Hero Section Component
const HeroSection = () => {
  const bgImages = [
    `${process.env.PUBLIC_URL}/logo192.png`,
    `${process.env.PUBLIC_URL}/logo512.png`,
    `${process.env.PUBLIC_URL}/logo192.png`
  ];
  const adBrands = [
    { name: 'ABET GLOBAL', img: `${process.env.PUBLIC_URL}/ads/abet-global.png` },
    { name: 'EXNESS', img: `${process.env.PUBLIC_URL}/ads/exness.png` },
    { name: 'XM', img: `${process.env.PUBLIC_URL}/ads/xm.png` },
    { name: 'FBS', img: `${process.env.PUBLIC_URL}/ads/fbs.png` },
    { name: 'FXTM', img: `${process.env.PUBLIC_URL}/ads/fxtm.png` },
    { name: 'OCTAFX', img: `${process.env.PUBLIC_URL}/ads/octafx.png` }
  ];

  return (
    <section className="hero">
      <div className="hero-slider">
        {bgImages.map((src, i) => (
          <div key={i} className="hero-slide" style={{ backgroundImage: `url(${src})` }} />
        ))}
        <div className="hero-overlay" />
      </div>

      <div className="container">
        <div className="hero-grid">
          <div className="hero-left">
            <h1 className="hero-title">Find Your Perfect Broker</h1>
            <div className="hero-search">
              <div className="hero-search-input">
                <span className="material-icons">search</span>
                <input type="text" placeholder="Search brokers by name" />
                <button className="hero-search-btn">Search</button>
              </div>
            </div>
          </div>
          <div className="hero-right">
            <div className="hero-ads">
              {adBrands.map((brand, idx) => (
                <div key={idx} className="hero-ad-card">
                  <img
                    className="hero-ad-img"
                    src={brand.img}
                    alt={brand.name}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = `${process.env.PUBLIC_URL}/forexumpire_logo.png`;
                      e.currentTarget.style.display = 'block';
                    }}
                  />
                  <span className="ad-badge">AD</span>
                </div>
              ))} 
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Main App Component
function App() {
  // Initialize state from URL to prevent flash of wrong page
  const getInitialStateFromURL = () => {
    if (typeof window === 'undefined') {
      return { page: 'home', broker: null };
    }
    const path = window.location.pathname;
    if (path === '/' || path === '') {
      return { page: 'home', broker: null };
    } else if (path.startsWith('/broker/')) {
      return { page: 'broker-details', broker: null }; // Broker will be set when data loads
    } else {
      const page = path.replace('/', '');
      if (['rankings', 'news', 'education', 'tools', 'brokers', 'markets'].includes(page)) {
        return { page: page, broker: null };
      } else {
        return { page: 'home', broker: null };
      }
    }
  };

  const initialState = getInitialStateFromURL();
  const [selectedLanguage, setSelectedLanguage] = useState('English');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(initialState.page);
  const [selectedBroker, setSelectedBroker] = useState(initialState.broker);
  const [isScrolled, setIsScrolled] = useState(false);
  const [topBrokers, setTopBrokers] = useState([]);
  const [brokersLoading, setBrokersLoading] = useState(true);
  const [brokersError, setBrokersError] = useState(null);
  const [brokerDetails, setBrokerDetails] = useState(null);
  const [brokerDetailsLoading, setBrokerDetailsLoading] = useState(false);
  const [brokerDetailsError, setBrokerDetailsError] = useState(null);
  const [lastFetchedBrokerId, setLastFetchedBrokerId] = useState(null);

  // Function to map API response to expected broker structure
  const mapApiBrokerToBroker = (apiBroker, index) => {
    // Extract spread value - use actual value from API
    let spreadValue = apiBroker.brokerSpreads || '';
    if (spreadValue && spreadValue.trim() !== '') {
      // Try to extract number if format is "From 2 pips"
      const spreadMatch = spreadValue.match(/(\d+(?:\.\d+)?)/);
      if (spreadMatch) {
        spreadValue = spreadMatch[1];
      }
    } else {
      spreadValue = '-';
    }
    
    // Format min deposit - use actual value from API
    let minDeposit = '-';
    if (apiBroker.brokerMinDeposit !== null && apiBroker.brokerMinDeposit !== undefined) {
      if (apiBroker.brokerMinDeposit === '' || apiBroker.brokerMinDeposit === 0) {
        minDeposit = '$0';
      } else {
        minDeposit = `$${apiBroker.brokerMinDeposit}`;
      }
    }
    
    // Get broker logo text (extract from logo URL or use first letters of name)
    const getLogoText = () => {
      if (apiBroker.brokerName && apiBroker.brokerName.trim() !== '') {
        const nameParts = apiBroker.brokerName.split(' ');
        if (nameParts.length > 0) {
          // Get first letter of each word, max 4 characters
          return nameParts.map(part => part[0]).join('').substring(0, 4).toUpperCase();
        }
        // Fallback to first 4 characters of name
        return apiBroker.brokerName.substring(0, 4).toUpperCase();
      }
      return '-';
    };

    return {
      id: apiBroker.brokerId || index + 1,
      name: apiBroker.brokerName || '-',
      rating: apiBroker.brokerRating !== null && apiBroker.brokerRating !== undefined 
        ? Math.max(0, Math.min(5, parseFloat(apiBroker.brokerRating) || 0)) 
        : 0,
      reviews: apiBroker.brokerReviewsCount !== null && apiBroker.brokerReviewsCount !== undefined 
        ? parseInt(apiBroker.brokerReviewsCount) || 0 
        : 0,
      spread: spreadValue,
      minDeposit: minDeposit,
      regulation: apiBroker.brokerAuthority || '-',
      logo: getLogoText(),
      logoUrl: apiBroker.brokerLogo || null,
      rank: index + 1,
      regulated: apiBroker.isBrokerVerified || false,
      slug: apiBroker.brokerSlug ? apiBroker.brokerSlug.trim() : null,
      // Store additional API data for future use
      apiData: apiBroker
    };
  };

  // Fetch brokers from API
  useEffect(() => {
    const fetchBrokers = async () => {
      try {
        setBrokersLoading(true);
        setBrokersError(null);
        
        const response = await fetch(`${config.API_BASE_URL}Brokers/GetBrokers`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        if (data.response && data.response.responseCode === 0 && data.result) {
          const mappedBrokers = data.result.map((broker, index) => mapApiBrokerToBroker(broker, index));
          setTopBrokers(mappedBrokers);
        } else {
          throw new Error(data.response?.responseMessage || 'Failed to fetch brokers');
        }
      } catch (error) {
        console.error('Error fetching brokers:', error);
        setBrokersError(error.message);
        // Set empty array on error
        setTopBrokers([]);
      } finally {
        setBrokersLoading(false);
      }
    };

    fetchBrokers();
  }, []);

  const stockTicker = [
    { symbol: 'EUR/USD', price: '1.0854', change: '+0.15%', trend: 'up' },
    { symbol: 'GBP/USD', price: '1.2654', change: '-0.08%', trend: 'down' },
    { symbol: 'USD/JPY', price: '148.25', change: '+0.22%', trend: 'up' },
    { symbol: 'USD/CHF', price: '0.8542', change: '-0.12%', trend: 'down' },
    { symbol: 'AUD/USD', price: '0.6548', change: '+0.18%', trend: 'up' },
    { symbol: 'USD/CAD', price: '1.3542', change: '-0.05%', trend: 'down' },
    { symbol: 'NZD/USD', price: '0.5985', change: '+0.25%', trend: 'up' },
    { symbol: 'EUR/GBP', price: '0.8578', change: '+0.08%', trend: 'up' }
  ];

  // Get translations for selected language
  const t = translations[selectedLanguage] || translations.English;

  // Scroll detection for sticky header
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Function to map API broker detail response to broker format
  const mapApiBrokerDetailToBroker = (apiBroker) => {
    // Extract spread value
    let spreadValue = 'N/A';
    if (apiBroker.brokerSpreads && apiBroker.brokerSpreads.trim() !== '') {
      const spreadMatch = apiBroker.brokerSpreads.match(/(\d+(?:\.\d+)?)/);
      if (spreadMatch) {
        spreadValue = spreadMatch[1];
      }
    }
    
    // Format min deposit
    let minDeposit = '-';
    if (apiBroker.brokerMinDeposit !== null && apiBroker.brokerMinDeposit !== undefined) {
      if (apiBroker.brokerMinDeposit === '' || apiBroker.brokerMinDeposit === 0) {
        minDeposit = '$0';
      } else {
        minDeposit = `$${apiBroker.brokerMinDeposit}`;
      }
    }
    
    // Get broker logo text
    const getLogoText = () => {
      if (apiBroker.brokerName && apiBroker.brokerName.trim() !== '') {
        const nameParts = apiBroker.brokerName.split(' ');
        if (nameParts.length > 0) {
          return nameParts.map(part => part[0]).join('').substring(0, 4).toUpperCase();
        }
        return apiBroker.brokerName.substring(0, 4).toUpperCase();
      }
      return '-';
    };

    return {
      id: apiBroker.brokerId || 0,
      name: (apiBroker.brokerName && apiBroker.brokerName.trim() !== '') ? apiBroker.brokerName : '-',
      rating: apiBroker.brokerRating !== null && apiBroker.brokerRating !== undefined 
        ? Math.max(0, Math.min(5, parseFloat(apiBroker.brokerRating) || 0)) 
        : 0,
      reviews: apiBroker.brokerReviewsCount !== null && apiBroker.brokerReviewsCount !== undefined 
        ? parseInt(apiBroker.brokerReviewsCount) || 0 
        : 0,
      spread: spreadValue,
      minDeposit: minDeposit,
      regulation: (apiBroker.brokerAuthority && apiBroker.brokerAuthority.trim() !== '') ? apiBroker.brokerAuthority : '-',
      logo: getLogoText(),
      logoUrl: (apiBroker.brokerLogo && apiBroker.brokerLogo.trim() !== '') ? apiBroker.brokerLogo : null,
      rank: 1,
      regulated: apiBroker.isBrokerVerified || false,
      slug: (apiBroker.brokerSlug && apiBroker.brokerSlug.trim() !== '') ? apiBroker.brokerSlug.trim() : null,
      apiData: apiBroker
    };
  };

  // Fetch broker details by ID
  const fetchBrokerById = async (brokerId) => {
    if (!brokerId) return;
    
    // Prevent duplicate API calls - if already loading or already fetched this broker
    if (brokerDetailsLoading || lastFetchedBrokerId === brokerId) {
      return;
    }
    
    try {
      setBrokerDetailsLoading(true);
      setBrokerDetailsError(null);
      setLastFetchedBrokerId(brokerId);
      
      const response = await fetch(`${config.API_BASE_URL}Brokers/BrokerById/${brokerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.response && data.response.responseCode === 0 && data.result) {
        const mappedBroker = mapApiBrokerDetailToBroker(data.result);
        setBrokerDetails(mappedBroker);
        setSelectedBroker(mappedBroker);
      } else {
        throw new Error(data.response?.responseMessage || 'Failed to fetch broker details');
      }
    } catch (error) {
      console.error('Error fetching broker details:', error);
      setBrokerDetailsError(error.message);
      setBrokerDetails(null);
      setLastFetchedBrokerId(null); // Reset on error so it can retry
    } finally {
      setBrokerDetailsLoading(false);
    }
  };

  const handleVisitBroker = (broker) => {
    if (broker.slug) {
      // Update URL with broker slug
      window.history.pushState({}, '', `/broker/${broker.slug}`);
    }
    // Fetch detailed broker data
    if (broker.id) {
      fetchBrokerById(broker.id);
    } else {
      setSelectedBroker(broker);
    }
    setCurrentPage('broker-details');
  };

  const handleBackToHome = () => {
    setSelectedBroker(null);
    setBrokerDetails(null);
    setLastFetchedBrokerId(null);
    setCurrentPage('home');
    window.history.pushState({}, '', '/');
  };

  // Initialize page from URL on mount and when brokers are loaded
  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/' || path === '') {
      setCurrentPage('home');
      setSelectedBroker(null);
      setBrokerDetails(null);
    } else if (path.startsWith('/broker/')) {
      const slug = path.replace('/broker/', '').trim();
      setCurrentPage('broker-details');
      
      // Try to find broker in loaded list first
      if (!brokersLoading && topBrokers.length > 0) {
        const broker = topBrokers.find(b => b.slug && b.slug.trim() === slug);
        if (broker && broker.id) {
          // Fetch detailed broker data
          fetchBrokerById(broker.id);
        } else {
          // Broker not in list, try to find by slug and get ID
          // For now, we'll need to fetch from API using slug or find another way
          // Since we don't have slug->ID mapping, we'll show error
          setBrokerDetailsError('Broker not found');
        }
      } else if (brokersLoading) {
        // Wait for brokers to load, then try again
        return;
      } else {
        // Brokers loaded but broker not found
        setBrokerDetailsError('Broker not found');
      }
    } else {
      const page = path.replace('/', '');
      if (['rankings', 'news', 'education', 'tools', 'brokers', 'markets'].includes(page)) {
        setCurrentPage(page);
        setSelectedBroker(null);
        setBrokerDetails(null);
      } else {
        setCurrentPage('home');
        setSelectedBroker(null);
        setBrokerDetails(null);
      }
    }
  }, [topBrokers, brokersLoading]); // Run when brokers are loaded

  // Handle URL changes (browser back/forward)
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      if (path === '/' || path === '') {
        setCurrentPage('home');
        setSelectedBroker(null);
      } else if (path.startsWith('/broker/')) {
        const slug = path.replace('/broker/', '').trim();
        // Find broker by slug
        const broker = topBrokers.find(b => b.slug && b.slug.trim() === slug);
        if (broker) {
          setSelectedBroker(broker);
          setCurrentPage('broker-details');
        } else {
          // If broker not found, try to stay on broker-details page
          setCurrentPage('broker-details');
        }
      } else {
        const page = path.replace('/', '');
        if (['rankings', 'news', 'education', 'tools', 'brokers', 'markets'].includes(page)) {
          setCurrentPage(page);
          setSelectedBroker(null);
        } else {
          setCurrentPage('home');
        }
      }
    };
    
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [topBrokers]);

  const renderPage = () => {
    switch (currentPage) {
      case 'rankings':
        return <BrokerRankingsSection t={t} brokers={topBrokers} loading={brokersLoading} error={brokersError} />;
      case 'news':
        return <NewsSection t={t} />;
      case 'education':
        return <EducationSection t={t} />;
      case 'tools':
        return <ToolsSection t={t} />;
      case 'brokers':
        return <TopBrokersSection topBrokers={topBrokers} t={t} onVisitBroker={handleVisitBroker} loading={brokersLoading} error={brokersError} />;
      case 'markets':
        return <MarketsPage t={t} />;
      case 'ads':
        return <AdsSection />;
      case 'broker-details':
        return <BrokerDetailsPage broker={brokerDetails || selectedBroker} t={t} onBackToHome={handleBackToHome} loading={brokerDetailsLoading || brokersLoading} error={brokerDetailsError || brokersError} />;
      default:
        return (
          <>
            <AdsSection />
            <TopBrokersSection topBrokers={topBrokers} t={t} onVisitBroker={handleVisitBroker} loading={brokersLoading} error={brokersError} />
            <BrokerRankingsSection t={t} brokers={topBrokers} loading={brokersLoading} error={brokersError} />
            <NewsSection t={t} />
            <BrokerInquirySection t={t} />
          </>
        );
    }
  };

  return (
    <div className="App">
      <TopWrapper 
        selectedLanguage={selectedLanguage}
        setSelectedLanguage={setSelectedLanguage}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        t={t}
        isScrolled={isScrolled}
      />
      
      <Navigation t={t} currentPage={currentPage} setCurrentPage={setCurrentPage} isScrolled={isScrolled} />
      
      <main className="main-content">
        {renderPage()}
      </main>
      <StockMarketSlider stockTicker={stockTicker} />
      <NewsletterSection />
      <Footer t={t} />
    </div>
  );
}

export default App;
